﻿/**
 * @private
 */
const ModelAnimationState = {
  STOPPED: 0,
  ANIMATING: 1,
};

export default Object.freeze(ModelAnimationState);
